import { message } from "ant-design-vue";

const convertArrayToObject = (array, key) => {
  const initialValue = {};
  return array.reduce((obj, item) => {
    return {
      ...obj,
      [item[key]]: item,
    };
  }, initialValue);
};
const maintainedErrorResponse = (error) => {
  if (Array.isArray(error)) {
    return convertArrayToObject(error);
  } else {
    return error;
  }
};

const errorHandler = (error) => {
  console.log(error, "error");

  //  || error.code === "ERR_NETWORK"
  if ([null, undefined].includes(sessionStorage.user)) {
    localStorage.clear();
    sessionStorage.clear();
    message.error("You have been logged out !!");
    window.location.reload();
    return;
  }
  if (error.code == "ERR_NETWORK") {
    return message.error(error.message);
  }
  if (error.response !== undefined || null) {
    if (error.response.status === 500) {
      message.error("Internal server error !!");
    } else if (error.response.status === 404) {
      message.error("404 : Page Not Found !!");
    } else if (error.response.status === 413 || error.response.status === 401) {
      localStorage.clear();
      sessionStorage.clear();
      if (error.response.data.detail) {
        message.error(error.response.data.detail);
      } else {
        message.error("User is Unauthorized !!");
      }
      window.location.reload();
    } else if (error.response.status === 400) {
      message.error("Bad request !!");
    } else {
      const response = maintainedErrorResponse(error);
      Object.keys(response).map((item) => {
        message.error(response[item]);
      });
    }
  } else {
    message.error("Something went Wrong !!");
  }
};

export default errorHandler;
